import { Component, isDevMode, OnInit } from '@angular/core';
import { Clinic } from '@models/clinic';
import { ClinicsService } from '../../../services/clinics.service';

@Component({
  selector: 'app-org-portal-settings',
  templateUrl: './org-portal-settings.component.html',
  styleUrls: ['./org-portal-settings.component.less'],
})
export class OrgPortalSettingsComponent implements OnInit {
  disableGrid = false;
  portalUrl = '';
  clinic: Clinic;
  clinicId: number;
  constructor(private clinicsService: ClinicsService) {}

  ngOnInit(): void {
    let origin = location.origin;
    const idx = origin.indexOf(':4200');
    if (isDevMode() && idx >= 0) {
      origin = origin.substring(0, idx) + ':4201';
    }
    this.portalUrl = origin + '/portal';
    this.clinicId = +localStorage.getItem('clinicId');
    this.clinicsService.getClinicById(this.clinicId).subscribe((snapshot) => {
      this.clinic = snapshot as Clinic;
    });
  }

  changeDisableGrid($event: boolean) {
    this.disableGrid = $event;
  }

  updateOnlineBooking() {
    this.clinicsService.updateClinicBookingSettings(this.clinic).subscribe(() => {});
  }
}
